import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  ["title", "Title of Activity", "col-span-2"],
  ["dates_offered", "Date(s) Offered", "col-span-2"],
  ["location", "Location (City, State)", ""],
  ["intended_audience", "Intended Audience (G, S, DH, DA, DL)", ""],
  ["num_students", "# of Students", ""],
  ["num_instructors", "# of Instructors", ""],
  ["method_of_delivery", "Method (L, PA, PR, SI, W)", ""],
  ["credit_hours", "Credit Hours Awarded", ""],
];
const YESNO = [
  ["prerequisite", "Prerequisite?"],
  ["offered_with_other_provider", "Offered with another Provider?"],
  ["financial_support", "Financial / in-kind support?"],
];

export function AGDCourseRow({ index, course, onChange }) {
  const set = (k) => (e) => onChange({ ...course, [k]: e.target.value });
  return (
    <div className="border rounded-lg p-4 bg-white space-y-3" data-testid={`agd-course-row-${index}`}>
      <p className="text-sm font-semibold" style={{ color: "#092036" }}>Course {index + 1}</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {FIELDS.map(([k, label, span]) => (
          <div key={k} className={span}>
            <Label className="text-xs text-slate-600">{label}</Label>
            <Input value={course[k] || ""} onChange={set(k)} data-testid={`agd-course-${index}-${k}`} />
          </div>
        ))}
        {YESNO.map(([k, label]) => (
          <div key={k}>
            <Label className="text-xs text-slate-600">{label}</Label>
            <select value={course[k] || "No"} onChange={set(k)} className="w-full h-10 px-3 rounded-md border bg-white text-sm" data-testid={`agd-course-${index}-${k}`}>
              <option>No</option>
              <option>Yes</option>
            </select>
          </div>
        ))}
      </div>
    </div>
  );
}
